import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"
import { useCampContext } from "~/contexts/CampProvider"

export const useCoupons = () => {
  const { campId } = useCampContext()
  return useQuery({
    queryKey: [queryKeys.COUPONS, campId],
    queryFn: () => fetchCoupons(campId),
    staleTime: 3000,
    enabled: !!campId,
  })
}

const fetchCoupons = async (campId: string) => {
  try {
    return await api2.Coupons.fetchForCamp(campId)
  } catch (error) {
    console.error("Error fetching Coupons:", error)
    throw error
  }
}
